import _defineProperty from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { UInt } from '../base/UInt.js';
/**
 * @name u256
 * @description
 * A 256-bit unsigned integer
 */
export class u256 extends UInt.with(256) {
  constructor() {
    super(...arguments);
    // NOTE without this, we cannot properly determine extensions
    _defineProperty(this, "__UIntType", 'u256');
  }
}